import React from 'react'
import { Tent, Loader2 } from '@/ui/icons'
import { Button } from '@/ui/components'
import { cn } from '@/shared/utils'

interface DispersedCampFinderToggleProps {
  showCampsites: boolean
  onToggle: (show: boolean) => void
  isLoading?: boolean
  className?: string
}

export function DispersedCampFinderToggle({
  showCampsites,
  onToggle,
  isLoading = false,
  className
}: DispersedCampFinderToggleProps) {
  return (
    <Button
      variant={showCampsites ? 'default' : 'outline'}
      size="sm"
      onClick={() => onToggle(!showCampsites)}
      className={cn(
        showCampsites
          ? 'w-fit shadow-md flex items-center gap-2'
          : 'w-fit bg-card shadow-md border border-border text-foreground hover:bg-earth-100 dark:hover:bg-earth-800/50 flex items-center gap-2',
        className
      )}
      title={showCampsites ? 'Hide camp finder' : 'Show dispersed camp finder'}
    >
      {isLoading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <Tent className="w-4 h-4" />
      )}
      <span className="text-xs font-medium">
        {showCampsites ? 'Hide Camp Finder' : 'Camp Finder'}
      </span>
    </Button>
  )
}
